import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import { useCalendarContext } from 'providers/CalendarProvider';
import * as yup from 'yup';

const enquirySchema = yup.object({
  name: yup.string().required('Hliday Name is mandatory'),
  date: yup.date().nullable().required('Holiday Date is required'),
});

export default function HolidayCreate({ open, setOpen }) {
  const { fetchHolidays } = useCalendarContext();
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(enquirySchema),
    defaultValues: {
      name: '',
      date: null,
    },
  });

  const onClose = () => {
    reset();
    setOpen(false);
  };

  const submitHoliday = async (data) => {
    try {
      const res = await post('users/holidays', { ...data, type: 'PUBLIC', isPaid: true });

      if (res.status == 200) {
        fetchHolidays();
        enqueueSnackbar(res.message || 'Holiday Added Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(res.message || 'Error While Adding Holiday', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error While Creating Holiday Try Again Latter', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      component="form"
      onSubmit={handleSubmit(submitHoliday)}
    >
      {/* HEADER */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 1 }}>
        <DialogTitle sx={{ fontSize: 20, fontWeight: 700 }}>Add Holiday</DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {/* BODY */}
      <DialogContent sx={{ px: 2 }}>
        {/* VENDOR */}
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Holiday Name"
                  error={!!errors.name}
                  helperText={errors.name?.message}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              name="date"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Holiday Date"
                  type="date"
                  variant="filled"
                  fullWidth
                  // InputLabelProps={{ shrink: true }}
                  error={!!errors.date}
                  helperText={errors.date?.message}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                    //   htmlInput: {
                    //     max: moment().format('YYYY-MM-DD'), // 👉 disables future dates in calendar
                    //     // onInvalid: (e) => e.preventDefault(), // ❗ blocks browser tooltip
                    //   },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" type="submit">
          Creat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
